import * as ContactConfig from "@energylab/shared-components/constants/config/contactConfig";

export const contactConfig: ContactConfig.ContactConfig = {
    imageUrl: "https://res.cloudinary.com/energylab/image/upload/v1561723053/generic-v2/contactbg.jpg",
    subjectOptions: [],
    siteKey: ContactConfig.contactConfig.siteKey
};
